import { Col, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import { URL } from "@/Redux/common/url";
import { Button, Modal } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import { allapiAction } from "../../Redux/common/action";
import NewHeader from "../Layout/NewHeader";
import NewSidebar from "../Layout/NewSidebar";
// import { allapiAction } from "@/Redux/common/action";
function BankBox() {
  const get_vendor_profiles = useSelector((state) =>
    state.allapi.get_profile ? state.allapi.get_profile : {}
  );
  const [show, setShow] = useState(false);
  const [userBuss, setuserBuss] = useState({});
  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  console.log(get_vendor_profiles);

  const hendleChangerole = (e) => {
    const { name, value } = e.target;
    setuserBuss({ ...userBuss, [name]: value });
  };
  const maxNumber = 1;
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (get_vendor_profiles) {
      // URL.API_BASE_URL + get_vendor_profiles?.sellerProfile

      setuserBuss(get_vendor_profiles?.kyc_id);
      // setImages([
      //   { data_url: URL.API_BASE_URL + get_vendor_profiles?.sellerProfile },
      // ]);
    }
  }, [get_vendor_profiles]);

  console.log(get_vendor_profiles);
  
  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImages(imageList);
  };
  const get_setting = useSelector((state) =>
    state.allapi.get_setting ? state.allapi.get_setting : {}
  ); 

  const submitProduct = () => {
    const data = new FormData();

    dispatch(
      allapiAction.kycUpdate({
        acc_holder: userBuss?.acc_holder,
        ifsc: userBuss?.ifsc,
        acc_no: userBuss?.acc_no,
        bank_name: userBuss?.bank_name,
        branch_name: userBuss?.branch_name,
      })
    );

    setShow(false);
  };
  return (
<div>
  <NewHeader />
  <NewSidebar />
  <div className="main">
    <Row gutter={[0, 20]}>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Bank Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              maxWidth: 600,
              margin: "0 auto",
              padding: 20,
              boxShadow: "0 5px 25px rgba(41, 128, 185, 0.15)",
              borderRadius: 10,
              backgroundColor: "#fff",
            }}
          >
            {[ 
              { label: "Account Holder", name: "acc_holder", placeholder: "Enter Account Holder" },
              { label: "Bank Name", name: "bank_name", placeholder: "Enter Bank Name" },
              { label: "Branch Name", name: "branch_name", placeholder: "Enter Branch Name" },
              { label: "Account Number", name: "acc_no", placeholder: "Enter Account Number" },
              { label: "IFSC Code", name: "ifsc", placeholder: "Enter IFSC Code" },
            ].map((field, index) => (
              <div key={index} style={{ marginBottom: 15 }}>
                <label style={{ fontWeight: 600, display: "block", marginBottom: 5 }}>
                  {field.label}
                </label>
                <input
                  name={field.name}
                  placeholder={field.placeholder}
                  type="text"
                  value={userBuss?.[field.name]}
                  onChange={hendleChangerole}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: 5,
                    border: "1px solid #ced4da",
                    fontSize: 14,
                  }}
                />
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitProduct}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Col lg={24} md={24} sm={24} xs={24}>
        <div
          style={{
            padding: 30,
            margin: 20,
            boxShadow: "0 5px 25px rgba(41, 128, 185, 0.15)",
            borderRadius: 15,
            background: "#fff",
          }}
        >
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            paddingBottom: 15,
            marginBottom: 30,
            flexWrap: "wrap"
          }}>
            <div style={{ fontSize: 20, fontWeight: 600 }}>
              Bank Information
            </div>
            <Tooltip title="Update">
              <span
                onClick={handleShow}
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "6px 12px",
                  borderRadius: 5,
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                Update
              </span>
            </Tooltip>
          </div>

          <div style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}>
            <div style={{ width: "100%", maxWidth: 600 }}>
              <div
                style={{
                  backgroundImage: "url(https://casandeepsharma.in.net/public/assets/back-end/img/bank-info-card-bg.png)",
                  backgroundPosition: "bottom",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  borderRadius: 12,
                  overflow: "hidden",
                  backgroundColor: "#f8f9fa",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                }}
              >
                <div
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    padding: 16,
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                  }}
                >
                  <h4 style={{ fontWeight: 600, marginBottom: 0 }}>
                    Holder Name:{" "}
                    <strong>
                      {get_vendor_profiles?.kyc_id?.acc_holder || "No Data Found"}
                    </strong>
                  </h4>
                </div>

                <div style={{ padding: 20, position: "relative" }}>
                  <img
                    src="https://casandeepsharma.in.net/public/assets/back-end/img/bank-card.png"
                    alt=""
                    width="78"
                    style={{ position: "absolute", top: 20, right: 20 }}
                  />
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {[
                      { label: "Bank Name", value: get_vendor_profiles?.kyc_id?.bank_name },
                      { label: "Branch Name", value: get_vendor_profiles?.kyc_id?.branch_name },
                      { label: "Account Number", value: get_vendor_profiles?.kyc_id?.acc_no },
                      { label: "IFSC", value: get_vendor_profiles?.kyc_id?.ifsc },
                    ].map((item, idx) => (
                      <li key={idx} style={{ marginBottom: 20 }}>
                        <h5 style={{ marginBottom: 6, fontWeight: 600 }}>
                          {item.label}:
                        </h5>
                        <div>{item.value || "No Data Found"}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</div>

  
  );
}

export default BankBox;
